import React from 'react'

export const Empty = () => {
  return (
    <div
      style={{
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <h4
        style={{
          alignSelf: 'center',
          textAlign: 'center',
        }}
      >
        <span role="img" aria-label="megaphone">
          📣
        </span>{' '}
        You’re all caught up! No notifications yet.
      </h4>
    </div>
  )
}

export default Empty
